import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4608169f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "tracking-number" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "final-pay" }
const _hoisted_5 = {
  class: "action",
  style: {"margin-top":"10px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_JobListItemTemplate = _resolveComponent("JobListItemTemplate")!

  return (_openBlock(), _createBlock(_component_JobListItemTemplate, _normalizeProps(_guardReactiveProps({ job: _ctx.job, personalJobType: _ctx.personalJobType })), {
    head: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.job.trackingNumber), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.job.title), 1)
      ])
    ]),
    personal: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_4, "$" + _toDisplayString(_ctx.job.myPay), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          onClick: _withModifiers(slotProps.showDetail, ["stop"])
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    _: 1
  }, 16))
}